<template>
  <div>
    <vxe-grid
      ref="refTable"
      :columns="tableColumn"
      :data="tableData"
      :min-height="30"
      :edit-config="tableConfig.editConfig"
      :mouse-config="tableConfig.mouseConfig"
      :keyboard-config="tableConfig.keyboardConfig"
      :rowConfig="{
        isCurrent: false
      }"
    >
      <template #edit_name="{ row }">
        <el-input v-model="row.name" size="mini" class="flex-1" />
      </template>
      <template #edit_spec="{ row }">
        <el-input v-model="row.spec" size="mini" class="flex-1" />
      </template>
      <template #edit_unit="{ row }">
        <el-input v-model="row.unit" size="mini" class="flex-1" />
      </template>
      <template #edit_counts="{ row }">
        <el-input v-model="row.counts" size="mini" class="flex-1" @input="calcGoodsAmount(row)" />
      </template>
      <template #edit_goods_price="{ row }">
        <el-input
          v-model="row.goods_price"
          size="mini"
          class="flex-1"
          @input="calcGoodsAmount(row)"
        />
      </template>
      <template #edit_get_counts="{ row }">
        <el-input v-model="row.get_counts" size="mini" class="flex-1" />
      </template>
      <template #edit_warehuose_name="{ row }">
        <el-input v-model="row.warehuose_name" size="mini" class="flex-1" />
      </template>
      <template #edit_remark="{ row }">
        <el-input v-model="row.remark" size="mini" class="flex-1" />
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      tableColumn: [
        {
          title: '序号',
          type: 'seq',
          width: 50
        },
        {
          title: '物料名称',
          field: 'name',
          slots: { edit: 'edit_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '规格',
          field: 'spec',
          slots: { edit: 'edit_spec' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单位',
          field: 'unit',
          slots: { edit: 'edit_unit' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '数量',
          field: 'counts',
          slots: { edit: 'edit_counts' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        },
        {
          title: '领料数量',
          field: 'get_counts',
          slots: { edit: 'edit_get_counts' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '仓位',
          field: 'warehuose_name',
          slots: { edit: 'edit_warehuose_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '备注',
          field: 'remark',
          slots: { edit: 'edit_remark' },
          editRender: { autofocus: '.el-input__inner' }
        }
      ],
      tableData: []
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return true
          }
        },
        keyboardConfig: {
          isEdit: true
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    tableData: {
      handler(newVal) {
        let result = this.$util.deepCopy(newVal)
        this.$emit('update:data', result)
      },
      deep: true
    }
  },
  mounted() {
    this.tableData = this.data || []
  },
  methods: {
    // 数量/单价变更时自动计算金额；任一为空或非数字时金额置空（保存时不写入快照，仍展示订单原金额）
    calcGoodsAmount(row) {
      let price =
        row.goods_price === '' || row.goods_price == null ? NaN : Number(row.goods_price)
      let counts = row.counts === '' || row.counts == null ? NaN : Number(row.counts)
      // 用 $set 写入，保证行原本没有 goods_amount 字段时也能触发金额列刷新
      this.$set(
        row,
        'goods_amount',
        isNaN(price) || isNaN(counts) ? '' : this.$XEUtils.multiply(price, counts)
      )
    }
  }
}
</script>

<style scoped>
.table-main {
}
</style>
